<template>
    <div style="border: white;margin-top: 130px;">
        <!-- <div class="Uselocation_header"></div> -->
        <div style="margin-top: 0px;">
            <el-card class="mart10">
                <div class="men">
                    <el-row>
                        <el-menu mode="horizontal" class="menu" active-text-color=" #56B275"
                            :default-active="activeIndex" style="display: flex;justify-content: center;">
                            <el-menu-item class="it" style="font-size: 20px;" :key="index"
                                v-for="(item, index) in menuList" :index="index" @click="pathto(item.name)">
                                {{ item.name }}
                            </el-menu-item>
                        </el-menu>
                    </el-row>
                </div>
            </el-card>
        </div>
        <!-- 提交需求 -->
        <div class="xq">
            <div v-for="(news, index) in newsSwipper" :key="index">
                <img :src="news.url" alt="" style="width: 100%;height: 100%;"
                    @click="$bus.$emit('openImage', news.url)">
                <div style="width: 100%;text-align: center;margin-top: 20px;color: #9CD08F;font-size: 20px;">●
                    {{ news.title }}</div>

            </div>
        </div>
    </div>
</template>

<script>

import { getproject } from '@/api';

import Vue from 'vue';
export default {
    // components: { globalTitle},
    name: 'anli',
    data() {
        return {
            activeIndex: 0,
            currentPage: 1, //通知公告的当前页
            pageSize: 20,
            total: 0, //通知公告新闻的总条数
            _sort: 'id',
            q: '',
            showImageFlag1: false,
            cont: [
            ],
            menuList: [
                { name: this.$t("user.uselocationt1"), id: 'quanbu' },
                { name: this.$t("user.uselocationt2"), id: 'jiaoyu' },
                { name: this.$t("user.uselocationt3"), id: 'yiliao' },
                { name: this.$t("user.uselocationt4"), id: 'dianshan' },
                { name: this.$t("user.uselocationt5"), id: 'fangdichan' },
                // { name: '社交', id: 'shejiao' },
            ],
            xiangqinglist: [],
            newsSwipper: [],
        }

    },
    created() { },
    mounted() {
        // this.$store.state.count='25'
        this.menuList = [
            { name: this.$t("user.uselocationt1"), id: 'quanbu' },
            { name: this.$t("user.uselocationt2"), id: 'jiaoyu' },
            { name: this.$t("user.uselocationt3"), id: 'yiliao' },
            { name: this.$t("user.uselocationt4"), id: 'dianshan' },
            { name: this.$t("user.uselocationt5"), id: 'fangdichan' },
            // { name: '社交', id: 'shejiao' },
        ],
            this.pathto();
    },
    methods: {
        pathto(name) {
            if (name === '全部') {
                getproject().then(
                    (res) => {
                        this.newsSwipper = res.data;
                    }
                )
            } else {
                getproject({ t: name }).then(
                    (res) => {
                        this.newsSwipper = res.data;
                    }
                )
            }
        },
        // getAll(item) {

        // },


        showImage1(index) {
            this.cont.forEach((item, i) => {
                if (i == index) {
                    item.showImage = 1;

                    console.log(this.showImageFlag1);
                } else {
                    item.showImage = 0;

                }
            });
        },
        hideImage1(index) {
            console.log(this.cont[index].showImage, 212)
            this.cont[index].showImage = 0;
        },
    }
}
</script>

<style lang="less" scoped>
// .Uselocation_header {
//     width: 100%;
//     height: 520px;
//     background: url(../assets/furuiImg/Uselocation.jpg);
//     background-size: cover;
//     background-position: center;
//     // margin-top: 80px;
// }

.men {
    width: 1000px;
    height: 60px;
    // border: 1px solid black;
    margin: auto;
}

.it {
    padding-left: 100px;
    color: #888888;
    font-weight: bold;
    border-color: #0065de;
    text-align: center;

}


.xq {
    margin-top: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 100px;
    justify-content: space-evenly;
    gap: 100px;
    //height: 140px;
    // border: 1px solid black;
    // background-image: url("../../../官网pc端/关于我们/7提交需求.jpg");
    // background-size: 100% 100%;
}

#overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* 半透明黑色背景 */

}

/deep/.el-menu-item {
    padding-left: 50px;
    padding-right: 50px;


}

/deep/.el-menu-item.it {
    border: transparent;
}

/deep/.el-menu-item.is-active {
    color: rgb(0, 101, 222);
    border-color: rgb(0, 101, 222);
    font-size: 20px;
    border: 2px solid;
    border-radius: 28px;
    border-bottom-color: unset !important;
}

// /deep/.el-menu--horizontal>.el-menu-item {
//   background-color: unset  !important;
// }
// img {
//       image-rendering: pixelated;
// }
img {

    image-rendering: -webkit-optimize-contrast;

}
</style>